/**
 * CalendarToolbar
 * Feature: 005-clinic-scheduling (T022)
 *
 * Custom toolbar with professional filter dropdown.
 */

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { useSchedulingProfessionals } from '../hooks/use-scheduling-professionals'

interface CalendarToolbarProps {
  selectedProfessionalId: string | null
  onProfessionalChange: (id: string | null) => void
}

export function CalendarToolbar({
  selectedProfessionalId,
  onProfessionalChange,
}: CalendarToolbarProps) {
  const { data: professionals, isLoading } = useSchedulingProfessionals()

  return (
    <div className="flex items-center gap-3 mb-4">
      <label className="text-sm font-medium text-muted-foreground whitespace-nowrap">
        Profissional:
      </label>
      <Select
        value={selectedProfessionalId ?? 'all'}
        onValueChange={(v) => onProfessionalChange(v === 'all' ? null : v)}
        disabled={isLoading}
      >
        <SelectTrigger className="w-[250px]">
          <SelectValue placeholder="Todos os profissionais" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Todos os profissionais</SelectItem>
          {(professionals ?? []).map((prof) => (
            <SelectItem key={prof.id} value={prof.id}>
              {prof.full_name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
